import { useCallback } from "react";

const debounce = (func, timeout = 1000) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

export const useDebounce = (callback, timeout = 1000) => {
  // eslint-disable-next-line
  const func = useCallback(debounce(callback, timeout), []);

  return func;
};
